import { Gift } from "lucide-react";
import { cn } from "@/lib/utils";

interface OfferBadgeProps {
  variant?: "onDark" | "onLight";
  size?: "sm" | "md";
  className?: string;
  /** Short label override. Defaults to the canonical badge copy. */
  label?: string;
}

/**
 * Promotional badge for the "First $10,000 in transfers — free" offer.
 * On-brand: navy + beige tokens, no raw green Tailwind classes.
 * Use variant="onDark" on #1e1e3c sections, "onLight" on #eeecdf or white.
 */
const OfferBadge = ({
  variant = "onLight",
  size = "md",
  className,
  label = "First $10,000 in transfers — free",
}: OfferBadgeProps) => {
  const isDark = variant === "onDark";
  const isSm = size === "sm";

  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 rounded-full font-semibold",
        isSm ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm",
        isDark
          ? "bg-[#eeecdf] text-[#1e1e3c] border border-[#eeecdf]/80 shadow-sm"
          : "bg-[#1e1e3c] text-[#eeecdf] border border-[#1e1e3c]",
        className
      )}
    >
      <span
        className={cn(
          "inline-flex items-center justify-center rounded-full font-bold uppercase tracking-wide",
          isSm ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]",
          isDark
            ? "bg-[#1e1e3c] text-[#eeecdf]"
            : "bg-[#eeecdf] text-[#1e1e3c]"
        )}
      >
        Free
      </span>
      <Gift className={cn(isSm ? "h-3 w-3" : "h-3.5 w-3.5")} aria-hidden />
      <span>{label}</span>
    </div>
  );
};

export default OfferBadge;
